export default __webpack_public_path__ + "static/media/tabela-de-medidas.7d690219.png";